import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import TransitionContainer from '../../components/Transition/TranstionContainer';
import CssTransition from '../../components/Transition/CssTransition';
import { TransitionGroup } from 'react-transition-group';

import ToasterAlert from '../../components/Donation/ToasterAlert';

import ElectionReminderForm from '../../components/ElectionReminder/ElectionReminderForm';

import { getActionCompletedTime } from '../../utils/actionTiming';
import { CardTypes } from '../../utils/enums';
import {
    getNextAction,
    buildConditionalActionsAnswerHistory
} from '../../utils/nextActionUtil';
import { handleSkippingEndCard } from '../../utils/handleSkippingEndCard';

import {
    ContainerStyled,
    LegalInfoWrapper,
    FormWrapper
} from '../../containers/DefaultStyles/AssessmentDetails';

import VoteRegistrationSidebar from '../../components/VoteRegistration/VoteRegistrationSidebar';

import LegalInfo from '../../components/Widget/LegalInfo';

import { onGoToNextCard } from '../Widget/actions';
import { onGoToStartScreen, submitElectionReminderForm } from './actions.js';
import { cacheFormData } from '../../utils/formCaching/actions';

const ElectionReminderDetails = props => (
    <TransitionContainer isSubmitting={props.isFormSubmitting} zIndex={2}>
        <ContainerStyled>
            <VoteRegistrationSidebar
                title={'Election Reminders Sign Up'}
                showReceiveUpdates={true}
            />
            <FormWrapper>
                <ElectionReminderForm
                    onBack={() => {
                        props.onGoToStartScreen(props.actionIdentifier);
                    }}
                    onSubmit={values => {
                        props.cacheFormData(values);
                        if (props.skipEndCard) {
                            props.handleSkippingEndCard(
                                props.nextAction,
                                props.cards,
                                props.onGoToNextCard
                            );
                        }
                        props.submitElectionReminderForm(
                            props.apiRequestData,
                            values,
                            props.isMultiActionsCard,
                            props.actionIdentifier,
                            props.actionCompletedTime(),
                            props.skipEndCard
                        );
                    }}
                    isFormSubmitting={props.isFormSubmitting}
                />
                {props.isMobileResolution && (
                    <LegalInfoWrapper>
                        <LegalInfo />
                    </LegalInfoWrapper>
                )}
            </FormWrapper>
            <TransitionGroup>
                {props.electionReminderError && (
                    <CssTransition key="alert" in={props.electionReminderError}>
                        <ToasterAlert content={props.electionReminderError} />
                    </CssTransition>
                )}
            </TransitionGroup>
        </ContainerStyled>
    </TransitionContainer>
);

ElectionReminderDetails.propTypes = {
    nextAction: PropTypes.object,
    isMobileResolution: PropTypes.bool,
    apiRequestData: PropTypes.object.isRequired,
    isFormSubmitting: PropTypes.bool,
    onGoToStartScreen: PropTypes.func.isRequired,
    submitElectionReminderForm: PropTypes.func.isRequired,
    electionReminderError: PropTypes.string,
    isMultiActionsCard: PropTypes.bool.isRequired,
    actionIdentifier: PropTypes.string.isRequired,
    actionCompletedTime: PropTypes.func.isRequired,
    cards: PropTypes.array.isRequired,
    skipEndCard: PropTypes.bool,
    onGoToNextCard: PropTypes.func.isRequired,
    handleSkippingEndCard: PropTypes.func.isRequired,
    cacheFormData: PropTypes.func.isRequired
};

export default connect(
    state => {
        const nextAction = getNextAction(
            state.widget.actions,
            state.widget.activeAction.identifier,
            buildConditionalActionsAnswerHistory(state),
            state.widget.cards
        );

        return {
            nextAction,
            isMobileResolution: state.widget.isMobileResolution,
            apiRequestData: state.widget.apiRequestData,
            isFormSubmitting: state.electionReminder.isFormSubmitting,
            electionReminderError: state.electionReminder.electionReminderError,
            isMultiActionsCard:
                state.widget.cards[state.widget.activeAction.order - 1].type ===
                CardTypes.multipleActions,
            actionIdentifier: state.widget.activeAction.identifier,
            actionCompletedTime: getActionCompletedTime(state, 'electionReminder'),
            cards: state.widget.cards,
            skipEndCard: state.widget.activeAction.skipEndCard && !!nextAction
        };
    },
    {
        onGoToStartScreen,
        submitElectionReminderForm,
        onGoToNextCard,
        handleSkippingEndCard,
        cacheFormData
    }
)(ElectionReminderDetails);



// WEBPACK FOOTER //
// ./src/containers/ElectionReminder/ElectionReminderDetails.jsx